var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h4", [_vm._v("Materias de Divulgação")]),
      _vm._v(" "),
      _c(
        "b-card",
        [
          _c(
            "b-card-body",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary", size: "sm" },
                      on: {
                        click: function($event) {
                          return _vm.openModal()
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fas fa-plus" }),
                      _vm._v(" Adicionar")
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-3 text-center md-10" },
                [
                  _vm.lista.length > 0
                    ? _c("b-table", {
                        attrs: {
                          striped: "",
                          hover: "",
                          items: _vm.lista,
                          fields: _vm.header,
                          busy: _vm.loadingTable
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "table-busy",
                              fn: function() {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-center text-danger my-2"
                                    },
                                    [
                                      _c("b-spinner", {
                                        staticClass: "align-middle"
                                      }),
                                      _vm._v(" "),
                                      _c("strong", [_vm._v("Carregando ...")])
                                    ],
                                    1
                                  )
                                ]
                              },
                              proxy: true
                            },
                            {
                              key: "cell(actions)",
                              fn: function(row) {
                                return [
                                  row.item.tipo == "VIDEO"
                                    ? _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            variant: "primary",
                                            size: "sm"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.detalhar(row.item)
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fab fa-youtube"
                                          })
                                        ]
                                      )
                                    : row.item.tipo == "IMAGEM"
                                    ? _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            variant: "primary",
                                            size: "sm"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.detalhar(row.item)
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-image"
                                          })
                                        ]
                                      )
                                    : row.item.tipo == "PDF"
                                    ? _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            variant: "primary",
                                            size: "sm"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.detalhar(row.item)
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-file-pdf"
                                          })
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              }
                            },
                            {
                              key: "cell(delete)",
                              fn: function(row) {
                                return [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        variant: "warning",
                                        size: "sm",
                                        title: "Editar"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.editar(row.item)
                                        }
                                      }
                                    },
                                    [_c("i", { staticClass: "fas fa-edit" })]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        variant: "secondary",
                                        title: "Excluir",
                                        size: "sm"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.excluir(row.item.id)
                                        }
                                      }
                                    },
                                    [_c("i", { staticClass: "fas fa-trash" })]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          23129146
                        )
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { size: "xl" },
          scopedSlots: _vm._u([
            {
              key: "modal-header",
              fn: function() {
                return [
                  _c("h4", [_vm._v(" Adicionar Material de Divulgação ")])
                ]
              },
              proxy: true
            },
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        disabled: _vm.loading,
                        variant: "success",
                        size: "sm"
                      },
                      on: { click: _vm.adicionar }
                    },
                    [
                      _vm.loading
                        ? _c("b-spinner", { attrs: { small: "" } })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.id
                        ? _c("span", [
                            _c("i", { staticClass: "fas fa-save" }),
                            _vm._v(
                              "\n                    Salvar\n                "
                            )
                          ])
                        : _c("span", [
                            _c("i", { staticClass: "fas fa-plus" }),
                            _vm._v(
                              "\n                    Adicionar\n                "
                            )
                          ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "danger", size: "sm" },
                      on: {
                        click: function($event) {
                          _vm.modalAdd = false
                        }
                      }
                    },
                    [_vm._v(" Cancelar")]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.modalAdd,
            callback: function($$v) {
              _vm.modalAdd = $$v
            },
            expression: "modalAdd"
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("label", { attrs: { for: "" } }, [_vm._v("Título")]),
                      _vm._v(" "),
                      _c("b-form-input", {
                        attrs: { placeholder: "Título" },
                        model: {
                          value: _vm.titulo,
                          callback: function($$v) {
                            _vm.titulo = $$v
                          },
                          expression: "titulo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-3" },
                [
                  _c(
                    "b-col",
                    [
                      _c("label", { attrs: { for: "desc" } }, [
                        _vm._v("Descrição")
                      ]),
                      _vm._v(" "),
                      _c("b-form-textarea", {
                        attrs: {
                          id: "desc",
                          placeholder: "Descreva o material...",
                          rows: "3",
                          "max-rows": "6"
                        },
                        model: {
                          value: _vm.descricao,
                          callback: function($$v) {
                            _vm.descricao = $$v
                          },
                          expression: "descricao"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-3" },
                [
                  _c(
                    "b-col",
                    [
                      _c("label", { attrs: { for: "camp" } }, [
                        _vm._v("Campanha")
                      ]),
                      _vm._v(" "),
                      _c("b-form-input", {
                        attrs: {
                          id: "camp",
                          placeholder: "Código da Campanha"
                        },
                        model: {
                          value: _vm.campanha,
                          callback: function($$v) {
                            _vm.campanha = $$v
                          },
                          expression: "campanha"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c("label", { attrs: { for: "class" } }, [
                        _vm._v("Classe Distribuidor")
                      ]),
                      _vm._v(" "),
                      _c("b-form-select", {
                        attrs: { options: _vm.opcoesClasse },
                        model: {
                          value: _vm.classe,
                          callback: function($$v) {
                            _vm.classe = $$v
                          },
                          expression: "classe"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c("label", { attrs: { for: "class" } }, [
                        _vm._v("Tipo de Material")
                      ]),
                      _vm._v(" "),
                      _c("b-form-select", {
                        attrs: { options: _vm.opcoesTipo },
                        model: {
                          value: _vm.tipo,
                          callback: function($$v) {
                            _vm.tipo = $$v
                          },
                          expression: "tipo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-3" },
                [
                  _c(
                    "b-col",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tipo === "VIDEO",
                          expression: "tipo === 'VIDEO'"
                        }
                      ]
                    },
                    [
                      _c("label", { attrs: { for: "vid" } }, [
                        _vm._v("Link do Video")
                      ]),
                      _vm._v(" "),
                      _c("b-form-input", {
                        attrs: { id: "vid" },
                        model: {
                          value: _vm.urlVideo,
                          callback: function($$v) {
                            _vm.urlVideo = $$v
                          },
                          expression: "urlVideo"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tipo === "IMAGEM" || _vm.tipo === "PDF",
                          expression: "tipo === 'IMAGEM' || tipo === 'PDF'"
                        }
                      ]
                    },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            description:
                              "Tamanho Máximo: 25Mb  -  Tipo: PDF, PNG, JPG, JPEG "
                          }
                        },
                        [
                          _c("label", { attrs: { for: "arq" } }, [
                            _vm._v("Arquivo")
                          ]),
                          _vm._v(" "),
                          _c("b-form-file", {
                            attrs: {
                              state: Boolean(_vm.newMaterialDownload.file),
                              placeholder: "Selecione um Arquivo..."
                            },
                            on: { change: _vm.onFileChange }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { size: "xl" },
          scopedSlots: _vm._u([
            {
              key: "modal-header",
              fn: function() {
                return [
                  _c("div", [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.itemModal.titulo) +
                        "\n            "
                    )
                  ])
                ]
              },
              proxy: true
            },
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { size: "sm", variant: "danger" },
                      on: {
                        click: function($event) {
                          _vm.modalVer = false
                        }
                      }
                    },
                    [_vm._v("Fechar")]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.modalVer,
            callback: function($$v) {
              _vm.modalVer = $$v
            },
            expression: "modalVer"
          }
        },
        [
          _vm._v(" "),
          _c("b-row", [
            _c("b", [_vm._v(" Descrição:    ")]),
            _vm._v(" " + _vm._s(_vm.itemModal.descricao) + "\n        ")
          ]),
          _vm._v(" "),
          _vm.itemModal.tipo === "VIDEO"
            ? _c(
                "b-row",
                { staticClass: "mt-3" },
                [
                  _c("b-col", { staticClass: "mt-2 col-md-12 text-center" }, [
                    _c(
                      "div",
                      [
                        _c("b-embed", {
                          attrs: {
                            type: "iframe",
                            aspect: "21by9",
                            src: _vm.itemModal.path,
                            allowfullscreen: ""
                          }
                        })
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            : _c(
                "b-row",
                [
                  _c("b-col", { staticClass: "mt-2 col-md-12 text-center" }, [
                    _c(
                      "div",
                      [
                        _c("b-img", {
                          attrs: { fluid: "", src: _vm.itemModal.path }
                        })
                      ],
                      1
                    )
                  ])
                ],
                1
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d6196d0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d6196d0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/material_divulgacao/Main.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-6d6196d0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/material_divulgacao/Main.vue
// module chunks = 2